  //    Search our certificate
  var opt = document.getElementById('mySelect');
    var but = document.getElementById("butn");
    but.onclick = function () {
        var selectIndex = opt.selectedIndex;
        var selectText = opt.options[selectIndex].text;
        if (selectText == 'NSF certificate') {
            window.location.href = "http://info.nsf.org/Certified/DWTU/"
        } else if (selectText == 'WQA certificate') {
            window.location.href = "https://www.wqa.org/find-products#/"
        } else if (selectText == 'IAPMO certificate') {
            window.location.href = "http://pld.iapmo.org/"
        }
    }

